import { render, staticRenderFns } from "./InvoiceCustomerDetail.vue?vue&type=template&id=a323457a&scoped=true"
import script from "./InvoiceCustomerDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a323457a",
  null
  
)

export default component.exports